'use strict';
var Google;

Google = {
  init: function(signinFlyout) {
    var $googleBtn;
    if (!($googleBtn = $('#ls-btn-google')).length) {
      return;
    }
    this.signinFlyout = signinFlyout;
    return $googleBtn.on('click', (function(_this) {
      return function() {
        return _this.signIn();
      };
    })(this));
  },
  signIn: function() {
    var authUrl, bCookie, params, returnTo, urlParams;
    $('#ls-signin-error').text('').hide();
    authUrl = 'https://accounts.google.com/o/oauth2/auth';
    bCookie = Cookie.get('b') || '';
    returnTo = window.location.href;
    params = {
      rememberMe: $('#ls-remember-me').prop('checked') ? 1 : 0,
      access_type: 'offline',
      response_type: 'code',
      client_id: Groupon.LS.data.googleClientId,
      redirect_uri: location.protocol + "//" + location.host + "/google_auth_callback",
      scope: 'profile email',
      state: bCookie + "@" + returnTo + "@metric:layout_login"
    };
    urlParams = _.map(params, function(val, key) {
      return key + "=" + (encodeURIComponent(val));
    }).join('&');
    Cookie.set('X-Google-Iframe', true);
    return this.openInPopup(authUrl + "?" + urlParams, 500, 600);
  },
  openInPopup: function(url, w, h) {
    var dualScreenLeft, dualScreenTop, height, left, top, width;
    dualScreenLeft = window.screenLeft ? window.screenLeft : screen.left;
    dualScreenTop = window.screenTop ? window.screenTop : screen.top;
    width = window.innerWidth ? window.innerWidth : (document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width);
    height = window.innerHeight ? window.innerHeight : (document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height);
    left = ((width / 2) - (w / 2)) + dualScreenLeft;
    top = ((height / 2) - (h / 2)) + dualScreenTop;
    return window.open(url, 'google_login_form', "width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
  }
};

module.exports = Google;

